export default __webpack_public_path__ + "static/media/quality-icon.0a0fdaa3.svg";